import { MsalProvider, useIsAuthenticated, useMsal } from "@azure/msal-react";
import { createContext, useContext, useState } from "react";
import { loginRequest, msalInstance } from "../authConfig";
import axios from 'axios';
import { doLogin } from "../services/authService";

const AppAuthContext = createContext();


const AppAuthProvider = ({children, ...rest}) =>
{
 
    const [loginComplete, setLoginComplete] = useState(false)
    const [processingLogin, setProcessingLogin] = useState(false)
    const [tenantName, setTenantName] = useState("Online Pass System");
    const [tenantLogo, setTenantLogo] = useState(null);
    const [managedHosts, setManagedHosts] = useState(undefined);
    const [vmsConfig, setVmsConfig] = useState(null);


    const isLoggedIn = useIsAuthenticated();

    const {accounts} = useMsal();
   
   
    // const doLoginOidc = (loginType)=>{  
    //     if (loginType === "popup") {
    //         instance.loginPopup(loginRequest).catch(e => {
    //             console.log(e);
    //         });
    //     } else if (loginType === "redirect") {
    //         instance.loginRedirect(loginRequest).catch(e => {
    //             console.log(e);
    //         });
    //     }
    // }
    // const loginCallback = async(account) =>{
    //     setUser(account); 
    //     instance.setActiveAccount(account);

       
    // }
 

    const loginOidc = (loginInf, callback) => {
 
          if (loginInf?.tenant)
          {
              setTenantName(loginInf.tenant.name)
              if(loginInf.tenant.logo)
              {
                setTenantLogo("data:image/jpeg;base64,"+loginInf.tenant.logo)
              }
              
          }
          if (loginInf?.vmsConfig)
          {
                //alert(JSON.stringify(loginInf.vmsConfig))
              setVmsConfig(loginInf.vmsConfig)
          }
          if (loginInf?.hosts)
          {
              setManagedHosts(loginInf.hosts)
          }
          else
          {
            setManagedHosts([])
          }

          if (callback) callback();
      };
    
    // const logout = (logoutType) => {
    //     if (logoutType === "popup") {
    //         instance.logoutPopup({
    //             postLogoutRedirectUri: "/",
    //             mainWindowRedirectUri: "/"
    //         });
    //     } else if (logoutType === "redirect") { 

    //         instance.logoutRedirect({
    //             postLogoutRedirectUri: "/",
    //              account: accounts[0] 
    //         });
    //     }
    // }

    const value = { userInfo:accounts?accounts[0]:accounts,
        isLoggedIn, 
        //doLoginOidc, logout,
        tenantName, setTenantName,
        tenantLogo, setTenantLogo,
        managedHosts,
        vmsConfig,loginOidc,
        loginComplete, setLoginComplete,
        processingLogin, setProcessingLogin
        };
    return(    
        
        <AppAuthContext.Provider  value={value}>
            {children}  
        </AppAuthContext.Provider>
    )
}

export default AppAuthProvider 

export const useAppAuthContext=()=> {
    return useContext(AppAuthContext);
}

